import {useEffect, useState} from 'react'

/**
 * Returns true while the document is visible. Polling queries should pass this
 * through to `enabled` so they pause when the tab is hidden.
 * @return {boolean}
 */
export function useDocumentVisible() {
    const [visible, setVisible] = useState(() =>
        typeof document === 'undefined' ? true : document.visibilityState !== 'hidden'
    )

    useEffect(() => {
        if (typeof document === 'undefined')
            return undefined
        const onChange = () => setVisible(document.visibilityState !== 'hidden')
        document.addEventListener('visibilitychange', onChange)
        return () => document.removeEventListener('visibilitychange', onChange)
    }, [])

    return visible
}
